import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  campaigns: [],
  odataItems: {},
  clientsCampaigns: [],
  campaignDetail: null,
  select: {},
  campaignCloneData: {},
  totalItemsPagination: 0,
  carFeatures: null,
  editCampaignFieldsChanged: {},
  selectDefault: {},
  editDataCampaign: {
    customers: {
      selectedDefault: [],
      associated: []
    },
    fields: {}
  },
  multipleCampaignsEdit: [],
  masterDataCampaign: {},
  newCampaign: {
    partnerId: null,
    partnerName: '',
    originCampaign: '',
    originURL: '',
    campaignName: '',
    campaignGroup: '',
    crcGroup: '',
    quoteId: null,
    quoteBufferIds: [],
    fromDate: '',
    toDateInvisibility: '',
    toDate: '',
    cancelCause: '',
    quoteIdSubstitute: '',
    partnerCampaignTracker: null,
    clients: [],
    contractValue: {
      contractName: '',
      contractId: '',
      version: '',
      logoPartnerLeft: '',
      logoPartnerRight: '',
      tableServices: [
        {
          lbl: 'Arrendamiento',
          val: 'No Incluido'
        },
        {
          lbl: 'Mantenimiento Profesional',
          val: 'No Incluido'
        },
        {
          lbl: 'Sustitución de neumáticos',
          val: 'No Incluido'
        },
        {
          lbl: 'Asistencia en carretera',
          val: 'No Incluido'
        },
        {
          lbl: 'Tramitación sanciones de tráfico',
          val: 'No Incluido'
        },
        {
          lbl: 'Impuesto matriculación',
          val: 'No Incluido'
        },
        {
          lbl: 'Impuesto circulación (IMC)',
          val: 'No Incluido'
        },
        {
          lbl: 'Seguro',
          val: 'No Incluido'
        },
        {
          lbl: 'Compromiso de Calidad',
          val: 'No Incluido'
        },
        {
          lbl: 'Vehículo de sustitución',
          val: 'No incluido'
        },
        {
          lbl: 'Telematics',
          val: 'No incorporado'
        }
      ],
      tableServicesPostSubtotal: {
        lbl: '',
        val: ''
      },
      contractTextTermConditions: '',
      contractTextDocumentsIncluded: [],
      contractTextInsurance: '',
      contractTextSelfDamageCost: '',
      contractTextServicesIncluded: [],
      emailSupport: '',
      contractTextWarranty: '',
      contractTextWarrantyFee: '',
      contractTextDebitReturnFee: '',
      firstDebitDueDate: '',
      nonPaymentCompensation: null,
      renter: {
        name: '',
        documentId: '',
        companyName: '',
        legalRepresentative: '',
        legalRepresentativeDocumentId: '',
        address: {
          address1: '',
          postalCode: '',
          city: '',
          province: ''
        },
        legalText: '',
        phone: '',
        email: '',
        customerCareEmail: '',
        customerCarePhone: '',
        billingEmail: ''
      },
      manualSignatureInstructions: null,
      signature: [],
      unpaidCompensation: '',
      cancelCompensation: null,
      generalClauses: null,
      contractGlobalMessage: null
    },
    risk: {
      documentsRequired: [],
      documentsRequiredOnStudy: [],
      riskFlowProvider: '',
      bankId: null
    },
    value: {
      channel: [],
      style: {},
      email: '',
      logoFrontLeft: '',
      logoFrontRight: '',
      phone: null,
      termInMonths: null,
      taxPercentage: null,
      taxType: null,
      vehicle: '',
      urlPhoto: [],
      make: '',
      model: '',
      version: '',
      doors: '',
      vehicleType: '',
      yearKms: null,
      accessories: '',
      monthFee: 0,
      legalText: '',
      phoneC2C: null,
      downPayment: 0,
      warrantyFee: 0,
      downPaymentText: null,
      kmExtra: 0,
      kmRefund: 0,
      settings: '',
      registrationYear: null,
      currentKilometers: null,
      deliveryProvinceCode: null,
      colorName: '',
      rangeKms: null,
      rangeKmsString: null,
      stockAlert: null,
      insuranceMonthFee: 0,
      totalAmountToBePaid: 0,
      warrantyFeeDescription: null,
      monthFeeWithoutTaxes: 0
    },
    campaignType: '',
    car: {
      multimediaFunctionality: null,
      vehicleSKU: {
        vehicleId: '0',
        vin: '0',
        plateNumber: null,
        id: null,
        timeStamp: '0001-01-01T00:00:00'
      },
      images: [],
      otherImages: [],
      acceleration: 0,
      accelerationUnitOfMeasure: '',
      bodyStyle: '',
      brand: '',
      bulletPoints: [],
      colorName: '',
      colorMap: '',
      configuration: '',
      cO2Emission: 0,
      cO2EmissionUnitOfMeasure: '',
      vehicleStatus: '',
      customAttributes: null,
      dgtLabel: null,
      dgtLabelUrl: null,
      driveSystem: 'F',
      engineDisplacement: 0,
      engineDisplacementUnitOfMeasure: '',
      engineType: '',
      jatoVersion: null,
      environmentalDescription: '-',
      firstRegistrationDate: '',
      fuelCapacity: 48,
      fuelCapacityUnitOfMeasure: '',
      fuelEconomyCity: 8.4,
      fuelEconomyCityUnitOfMeasure: '',
      fuelEconomyHighway: 5.8,
      mileageUnitOfMeasure: null,
      fuelEconomyHighwayUnitOfMeasure: '',
      fuelEconomyCombined: 6.7,
      fuelEconomyCombinedUnitOfMeasure: '',
      fuelType: '',
      genericKeywords: [],
      includedFeature: '',
      indications: null,
      insuranceGroup: '',
      interiorColor: '',
      interiorColorName: '',
      itemDimensionsUnitOfMeasure: '',
      itemWeightUnitOfMeasure: '',
      itemHeight: 0,
      itemLength: 0,
      itemWidth: 0,
      itemWeight: 0,
      maximumCompatibleNumberSeats: 0,
      maximumHorsepower: 0,
      maximumHorsepowerUnitOfMeasure: null,
      maximumOperatingDistance: null,
      maximumOutputPower: '                                                          ',
      maximumSpeed: 0,
      maximumSpeedUnitOfMeasure: '',
      model: '',
      modelName: '',
      modelYearRange: '',
      plateNumber: null,
      numberOfDoors: 0,
      paymentSchedule: null,
      seatMaterial: '',
      specialFeatures: null,
      storageVolume: null,
      storageVolumeUnitOfMeasure: null,
      reportExpertiseURL: null,
      tireType: '',
      transmissionType: '',
      wheels: '',
      wheelMaterial: null,
      wheelBase: null,
      wheelBaseUnitOfMeasure: null,
      year: 0,
      euEnergyLabelEfficiencyClass: null,
      partNumber: null,
      productTaxCode: null,
      options: null,
      wltpLabel: '',
      currentKilometers: 0
    },
    marketplacePublication: [],
    stock: {
      free: 0,
      available: 0,
      reserved: 0,
      contracted: 0,
      risk: 0,
      inProcess: 8,
      pending: 0,
      total: 23,
      otrosCanales: 10,
      fecha_disponibilidad_vehiculo: ''
    },
    customersAsocciated: [],
    customFormGroup: null,
    campaignQuoteBucket: null,
    campaignMasterBucket: null,
    pricings: [],
    marketplaceContents: null,
    omegaGroupId: '',
    parentOmegaId: '',
    campaignParentId: '',
    insuranceMonthFeeRequired: false,
    location: null,
    salePrices: null,
    id: '',
    timeStamp: '',
    reservedQuotes: null
  },
  useToSort: [],
  sortedCampaigns: [],
  hasMoveCampaign: false
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
